import { createRequest, getEndpoint } from "../requestCreator";

export const sendTestEmail = createRequest(getEndpoint("mail.sub.testEmail"));
